import { SideSheet } from "@opensea/ui-kit"
import { SyncAlt } from "@opensea/ui-kit/icons"
import { useState } from "react"
import type { SwapFlowInitialCurrency } from "../../flow/flow-state"
import { SwapFlow } from "../../flow/SideSheetFlows/SwapFlow"
import { Button } from "../Button"

type Props = {
  onBack?: () => void
  onClose?: () => void
  initialFromCurrency: SwapFlowInitialCurrency
  initialToCurrency: SwapFlowInitialCurrency
}

export function InlineSwapButton({
  onBack,
  onClose,
  initialFromCurrency,
  initialToCurrency,
}: Props) {
  const [open, setOpen] = useState(false)

  return (
    <SideSheet
      content={
        <SwapFlow
          initialFromCurrency={initialFromCurrency}
          initialToCurrency={initialToCurrency}
          onBack={() => {
            setOpen(false)
            onBack?.()
          }}
          onClose={() => {
            setOpen(false)
            onClose?.()
          }}
        />
      }
      direction="right"
      nested
      onOpenChange={setOpen}
      open={open}
      overrides={{
        Overlay: {},
      }}
    >
      <Button
        icon={SyncAlt}
        onClick={() => setOpen(true)}
        size="sm"
        variant="secondary"
      />
    </SideSheet>
  )
}
